<avn-page>
  <avn-main>
    <avn-master-detail [resizable]="true" [activeDetailView]="activeDetailView" [detailWidth]="'50%'" [masterMinWidthPx]="700" [detailMinWidthPx]="350" [transitionPlayBackwards]="index === 0">
      <!-- Board org path tree + Preview -->
      <div avnMasterView class="board-orgpath-section board-orgpath-edit-definition">
        <ng-container *avnAsyncData="siteOrgPathDef$ | async; state: siteOrgPathState$ | async; loaderType: 'loader'">
          <!-- Tree -->
          <h4>{{ 'siteManagementScope.SITE_MANAGEMENT.SITE_EDITOR.GLOBAL.SITE_DEFINITION_40' | transloco }}</h4>

          <div class="board-orgpath-tree" avnScroll>
            <amp-site-orgpath-tree class="board-orgpath-tree-root" *ngIf="siteOrgPathDef$ | async as orgPathNode" [id]="orgPathNode.id" [editable]="editable$ | async"> </amp-site-orgpath-tree>
          </div>

          <!-- Empty message if empty tree -->
          <avn-empty-data-message
            *ngIf="(siteOrgPathDef$ | async) === undefined"
            class="empty-constraint"
            icon="action:add_circle_outline"
            [text]="'siteManagementScope.SITE_MANAGEMENT.GLOBAL.ORGANIZATIONAL_PATH.ORGPATH_EDITOR.NO_EXISTING_ORGPATH_TEXT_100' | transloco"
            [subText]="'siteManagementScope.SITE_MANAGEMENT.GLOBAL.ORGANIZATIONAL_PATH.ORGPATH_EDITOR.NO_EXISTING_ORGPATH_SUBTEXT_100' | transloco"
            (click)="addFirstNode()"
          ></avn-empty-data-message>

          <!-- Footer -->
          <div class="board-orgpath-footer">
            <div class="board-orgpath-buttons-footer">
              <avn-button
                *ngIf="activeDetailView?.id !== '3'"
                class="board-orgpath-save-button"
                [label]="'siteManagementScope.SITE_MANAGEMENT.GLOBAL.ORGANIZATIONAL_PATH.ORGPATH_EDITOR.SHOW_PREVIEW_50' | transloco"
                avnTheme="primary"
                [disabled]="hasErrors$ | async"
                (actioned)="openPreview(true)"
              ></avn-button>

              <avn-button
                *ngIf="activeDetailView?.id === '3'"
                class="board-orgpath-save-button"
                [label]="'siteManagementScope.SITE_MANAGEMENT.GLOBAL.ORGANIZATIONAL_PATH.ORGPATH_EDITOR.HIDE_PREVIEW_50' | transloco"
                avnTheme="primary"
                (actioned)="openPreview(false)"
              ></avn-button>

              <avn-button
                *ngIf="editable$ | async"
                class="board-orgpath-save-button"
                [disabled]="(isSaved$ | async) || (siteOrgPathDef$ | async) === undefined"
                [label]="'button.save' | transloco"
                avnTheme="primary"
                (actioned)="onSaveSiteOrgPathDef()"
              >
              </avn-button>
            </div>
          </div>
        </ng-container>
      </div>

      <!------ Side menus ------>
      <!-- Current node (2 side menu for transition between 2 nodes) -->
      <ng-template [avnDetailView]="'0'">
        <amp-site-orgpath-node-editor
          [node]="index === 0 ? activeNode : previousNode"
          [editable]="editable$ | async"
          class="board-orgpath-node-editor"
          (openEditTagPanel)="openEditTagPanel()"
          (openAddTagPanel)="openAddTagPanel()"
        ></amp-site-orgpath-node-editor>
      </ng-template>
      <ng-template [avnDetailView]="'1'">
        <amp-site-orgpath-node-editor
          [node]="index === 1 ? activeNode : previousNode"
          [editable]="editable$ | async"
          class="board-orgpath-node-editor"
          (openEditTagPanel)="openEditTagPanel()"
          (openAddTagPanel)="openAddTagPanel()"
        ></amp-site-orgpath-node-editor>
      </ng-template>

      <!-- Edit Tag  -->
      <ng-template [avnDetailView]="'2'">
        <ng-container *ngIf="siteTagsDefinition$ | async as tagDefinition">
          <amp-tag-key-detail
            [tag]="{ key: activeNode.tag, level: engineTagLevel.SITE, description: tagDefinition[activeNode.tag] }"
            [getInvalidTagsFn]="getInvalidTag"
            [editable]="editable$ | async"
            [removeMultivalue]="true"
            (editTag)="editTag($event)"
            (closed)="goToCurrentNode()"
          ></amp-tag-key-detail>
        </ng-container>
      </ng-template>

      <!-- Preview Org path -->
      <ng-template [avnDetailView]="'3'">
        <avn-detail-layout [class.disabled]="(editable$ | async) === false">
          <avn-detail-header [title]="'siteManagementScope.SITE_MANAGEMENT.BOARD_EDITOR.GLOBAL.PREVIEW_20' | transloco" (closed)="openPreview(false)"> </avn-detail-header>
          <avn-detail-content avnScroll *ngIf="siteOrgPathDef$ | async as boardOrgPathNode">
            <form [formGroup]="formGroup">
              <amp-orgpath-form-group
                class="board-orgpath-preview-content"
                *ngIf="siteTagsDefinition$ | async as tagDefinition"
                [tagDefinition]="tagDefinition | applyFunction : getSchemaFromTagDesc"
                [nodeDefinition]="boardOrgPathNode"
                [editable]="editable$ | async"
                avnScroll
              >
              </amp-orgpath-form-group>
            </form>
          </avn-detail-content>
        </avn-detail-layout>
      </ng-template>
    </avn-master-detail>
  </avn-main>
</avn-page>
